<template>
  <a
      class="interactive"
      :class="classes"
      @click="handleClick"
  >
    {{ label }}
  </a>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: 'button primary'
    },
    label: {
      type: String,
      required: false,
      default: 'Hire a space today'
    }
  },
  methods: {
    handleClick () {
      if (!this.$store.getters['user/account']) {
        return this.$store.commit('user/changeAuthMode', 'login')
      }
      window.location = '/explore'
    }
  }
}
</script>
